import React from 'react'
import { Col, Row } from '@cx/couturier/Grid'
import Success3Icon from '@cx/couturier/icons/utils/Success3'
import styled, { css } from 'styled-components'
import LogBackInBtn from './log-back-in-btn'

const Title = styled.h4`
  && {
    font-weight: 300;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.primary.nmBlue};
  }
  text-align: left;
  padding-left: 0.5rem;
  ${({ theme: { media } }) =>
    media.medium(css`
      && {
        font-size: 1.5rem;
      }
      padding-left: 1rem;
    `)};
`
const TitleWrapper = styled.div`
  margin: 20px 0.25rem 43px 0.25rem;
  padding: 22px 0 22px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutral.quarter}`};
`

function HeaderTitleWrapper () {
  return (
    <TitleWrapper>
      <Row align='center'>
        <Col className='knightRider' small={12}>
          <Success3Icon />
          <Title>You&#39;ve successfully logged out.</Title>
        </Col>
      </Row>
      <Row align='center'>
        <LogBackInBtn passedClass='mobile-only' />
      </Row>
    </TitleWrapper>
  )
}

export default HeaderTitleWrapper
